import React from 'react';
import Icon from '../../../../components/AppIcon';

const CompanySelector = ({
  companies,
  selectedCompanyA,
  selectedCompanyB,
  onSelectCompanyA,
  onSelectCompanyB,
  onNext,
  simulating
}) => {
  const availableCompaniesB = companies?.filter(c => c?.id !== selectedCompanyA?.id);
  const canProceed = selectedCompanyA && selectedCompanyB;

  return (
    <div className="space-y-6">
      {/* Company A Selector */}
      <div className="bg-white rounded-xl shadow-sm border border-border p-6">
        <div className="flex items-center space-x-2 mb-4">
          <div className="w-8 h-8 bg-primary-100 rounded-lg flex items-center justify-center">
            <span className="text-primary font-bold">A</span>
          </div>
          <div>
            <h2 className="text-lg font-semibold text-text-primary">Primary Company</h2>
            <p className="text-sm text-text-secondary">This company will become the master account</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {companies?.map((company) => (
            <div
              key={company?.id}
              onClick={() => onSelectCompanyA(company)}
              className={`p-4 border-2 rounded-lg cursor-pointer transition-all duration-200 ${
                selectedCompanyA?.id === company?.id
                  ? 'border-primary bg-primary-50' :'border-border hover:border-primary-300 hover:bg-secondary-50'
              }`}
            >
              <div className="flex items-center space-x-3">
                <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${
                  selectedCompanyA?.id === company?.id ? 'bg-primary' : 'bg-secondary-200'
                }`}>
                  <span className={`font-bold ${
                    selectedCompanyA?.id === company?.id ? 'text-white' : 'text-text-secondary'
                  }`}>
                    {company?.company_tag?.slice(0, 2)?.toUpperCase()}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-text-primary truncate">{company?.company_name}</h3>
                  <p className="text-sm text-text-secondary">@{company?.company_tag}</p>
                </div>
                {selectedCompanyA?.id === company?.id && (
                  <Icon name="CheckCircle2" size={24} color="#3B82F6" />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Merge Direction Indicator */}
      {selectedCompanyA && (
        <div className="flex justify-center">
          <div className="flex items-center space-x-2 px-4 py-2 bg-secondary-100 rounded-full">
            <Icon name="ArrowDown" size={20} color="#64748B" />
            <span className="text-sm font-medium text-text-secondary">Merge Direction</span>
            <Icon name="ArrowDown" size={20} color="#64748B" />
          </div>
        </div>
      )}

      {/* Company B Selector */}
      {selectedCompanyA && (
        <div className="bg-white rounded-xl shadow-sm border border-border p-6">
          <div className="flex items-center space-x-2 mb-4">
            <div className="w-8 h-8 bg-secondary-200 rounded-lg flex items-center justify-center">
              <span className="text-text-secondary font-bold">B</span>
            </div>
            <div>
              <h2 className="text-lg font-semibold text-text-primary">Secondary Company</h2>
              <p className="text-sm text-text-secondary">This company will be merged into Company A</p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {availableCompaniesB?.map((company) => (
              <div
                key={company?.id}
                onClick={() => onSelectCompanyB(company)}
                className={`p-4 border-2 rounded-lg cursor-pointer transition-all duration-200 ${
                  selectedCompanyB?.id === company?.id
                    ? 'border-secondary-500 bg-secondary-50' :'border-border hover:border-secondary-300 hover:bg-secondary-50'
                }`}
              >
                <div className="flex items-center space-x-3">
                  <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${
                    selectedCompanyB?.id === company?.id ? 'bg-secondary-500' : 'bg-secondary-200'
                  }`}>
                    <span className={`font-bold ${
                      selectedCompanyB?.id === company?.id ? 'text-white' : 'text-text-secondary'
                    }`}>
                      {company?.company_tag?.slice(0, 2)?.toUpperCase()}
                    </span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-semibold text-text-primary truncate">{company?.company_name}</h3>
                    <p className="text-sm text-text-secondary">@{company?.company_tag}</p>
                  </div>
                  {selectedCompanyB?.id === company?.id && (
                    <Icon name="CheckCircle2" size={24} color="#64748B" />
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Action Buttons */}
      <div className="flex justify-end space-x-3">
        <button
          onClick={onNext}
          disabled={!canProceed || simulating}
          className={`px-6 py-3 rounded-lg font-medium transition-all duration-200 flex items-center space-x-2 ${
            canProceed && !simulating
              ? 'bg-primary text-white hover:bg-primary-700' :'bg-secondary-200 text-secondary-500 cursor-not-allowed'
          }`}
        >
          {simulating ? (
            <>
              <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              <span>Running Simulation...</span>
            </>
          ) : (
            <>
              <span>Run Merge Simulation</span>
              <Icon name="ArrowRight" size={20} />
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default CompanySelector;